import {
  PageLayout,
  PageLayoutContent,
} from "@clockwise/web-commons/src/ui/page-layout/PageLayout";
import React, { useEffect } from "react";
import Helmet from "react-helmet";
import FlexibleHolds from "../components/flexible-holds/FlexibleHolds";
import { PageEvents, page } from "../util/analytics.util";

const FlexibleHoldsPage = () => {
  useEffect(() => {
    page(PageEvents.FLEXIBLE_HOLDS_PAGE);
  }, []);

  return (
    <>
      <Helmet>
        <title>Flexible holds · Clockwise</title>
      </Helmet>
      <PageLayout
        title="Flexible holds"
        description="Flexible holds are events where you are the only attendee. Exactly when they happen doesn’t
      matter, just that they do. As your schedule changes throughout the week, Clockwise will
      automatically shuffle your flexible holds so your calendar reacts as your day evolves."
      >
        <PageLayoutContent>
          <FlexibleHolds />
        </PageLayoutContent>
      </PageLayout>
    </>
  );
};

export default FlexibleHoldsPage;
